/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ReferenceBookType {
    ACCOUNT_STATUS = 'ACCOUNT_STATUS',
    AI_ANALYST_RATE = 'AI_ANALYST_RATE',
    AI_ANALYST_REASON = 'AI_ANALYST_REASON',
    AI_ANALYST_SECTION = 'AI_ANALYST_SECTION',
    ATTACHED_DOC = 'ATTACHED_DOC',
    BASED_ON = 'BASED_ON',
    BIC = 'BIC',
    BIN = 'BIN',
    BIN_TYPES = 'BIN_TYPES',
    BORROWER_CATEGORY = 'BORROWER_CATEGORY',
    CALL_CONTACT_TYPE = 'CALL_CONTACT_TYPE',
    CARD_BIN = 'CARD_BIN',
    CASINO_GREY = 'CASINO_GREY',
    CATEGORY = 'CATEGORY',
    CATEGORY_BASE = 'CATEGORY_BASE',
    CONFIRMATION_METHOD = 'CONFIRMATION_METHOD',
    CONTACT_REASON = 'CONTACT_REASON',
    CONTACT_TIMEFRAME = 'CONTACT_TIMEFRAME',
    CONTACT_TYPE = 'CONTACT_TYPE',
    COUNTRY = 'COUNTRY',
    CURRENCY = 'CURRENCY',
    DELETED_BASED = 'DELETED_BASED',
    DROPPER = 'DROPPER',
    EMAIL_CONTACT_TYPE = 'EMAIL_CONTACT_TYPE',
    FAQ_CATEGORY = 'FAQ_CATEGORY',
    FORGIVENESS_REASON = 'FORGIVENESS_REASON',
    FRAUDSTER_ROLE = 'FRAUDSTER_ROLE',
    FRAUD_REPORT_STATUS = 'FRAUD_REPORT_STATUS',
    FRAUD_REPORT_TYPE = 'FRAUD_REPORT_TYPE',
    FRAUD_SCHEME = 'FRAUD_SCHEME',
    FRAUD_TYPE = 'FRAUD_TYPE',
    GENDER = 'GENDER',
    INCIDENT_REFUND_STATUS = 'INCIDENT_REFUND_STATUS',
    INCIDENT_ROLE = 'INCIDENT_ROLE',
    INCIDENT_STATUS = 'INCIDENT_STATUS',
    INCIDENT_TYPE = 'INCIDENT_TYPE',
    INTERNET_CONTACT_TYPE = 'INTERNET_CONTACT_TYPE',
    KNOWLEDGE_BASE_DOCS = 'KNOWLEDGE_BASE_DOCS',
    LOAN_STATUS = 'LOAN_STATUS',
    LOAN_TYPE = 'LOAN_TYPE',
    MERCHANT_CATEGORY_CODE = 'MERCHANT_CATEGORY_CODE',
    MESSENGER_CONTACT_SUBTYPE = 'MESSENGER_CONTACT_SUBTYPE',
    MESSENGER_CONTACT_TYPE = 'MESSENGER_CONTACT_TYPE',
    MOBILE_OPERATOR = 'MOBILE_OPERATOR',
    MOBILE_OPERATOR_EVENT_SOURCE = 'MOBILE_OPERATOR_EVENT_SOURCE',
    MSISDN_STATUS = 'MSISDN_STATUS',
    NOTIFICATION_TYPE = 'NOTIFICATION_TYPE',
    ORG_TYPE = 'ORG_TYPE',
    PYRAMID_GREY = 'PYRAMID_GREY',
    REFERENCE = 'REFERENCE',
    REFUND_GROUNDS = 'REFUND_GROUNDS',
    REFUND_STATUS = 'REFUND_STATUS',
    REFUND_TYPE = 'REFUND_TYPE',
    REGION = 'REGION',
    REJECT_TYPE = 'REJECT_TYPE',
    REQUISITE_TYPE = 'REQUISITE_TYPE',
    SOCIAL_CONTACT_TYPE = 'SOCIAL_CONTACT_TYPE',
    SOURCE_TYPE = 'SOURCE_TYPE',
    SUBSCRIBER_CATEGORY = 'SUBSCRIBER_CATEGORY',
    SUBJECT_CREATION_REASON = 'SUBJECT_CREATION_REASON',
    SUSPENSION_REASON = 'SUSPENSION_REASON',
    TRANSACTION_CATEGORY = 'TRANSACTION_CATEGORY',
    TRANSACTION_CHANNEL = 'TRANSACTION_CHANNEL',
    TRANSACTION_COMPLETION_STATUS = 'TRANSACTION_COMPLETION_STATUS',
    TRANSACTION_STATUS = 'TRANSACTION_STATUS',
    TRANSACTION_TYPE = 'TRANSACTION_TYPE',
    TREND_CONFIDENCE = 'TREND_CONFIDENCE',
    TREND_RATE = 'TREND_RATE',
    TREND_REASON = 'TREND_REASON',
    TREND_RELEVANCE = 'TREND_RELEVANCE',
    TREND_STATUS = 'TREND_STATUS',
    TREND_TYPE = 'TREND_TYPE',
    VICTIM = 'VICTIM',
    VICTIM_ACTION = 'VICTIM_ACTION',
    WITNESS = 'WITNESS'
}

